import { ProductIdent } from "@coaching-culture/types";
import styled from "styled-components";

const IconSvg = styled.svg`
  fill: ${(props) => props.theme.colors[props.color]};
  height: 32px;
  width: 32px;
  margin-right: 12px;
`;

type IconProps = {
  color?: string;
};

const LessonsIcon = ({ color }: IconProps) => (
  <IconSvg viewBox="0 0 281.41 268.09" color={color}>
    <g>
      <g>
        <path d="M140.7,0C63.12,0,0,60.13,0,134.05s63.12,134.05,140.7,134.05,140.71-60.13,140.71-134.05S218.29,0,140.7,0Zm0,220.77c-50.2,0-91.03-38.91-91.03-86.73S90.51,47.32,140.7,47.32s91.04,38.91,91.04,86.73-40.84,86.73-91.04,86.73Z" />
        <circle cx="114.35" cy="150.2" r="11.08" />
        <circle cx="114.35" cy="183.45" r="11.08" />
        <circle cx="114.35" cy="116.95" r="11.08" />
        <circle cx="114.35" cy="83.71" r="11.08" />
        <circle cx="140.16" cy="135.54" r="11.08" />
        <circle cx="140.16" cy="168.79" r="11.08" />
        <circle cx="140.16" cy="102.3" r="11.08" />
        <circle cx="166.41" cy="152.03" r="11.08" />
        <circle cx="166.41" cy="118.78" r="11.08" />
        <circle cx="191.79" cy="135.8" r="11.08" />
      </g>
    </g>
  </IconSvg>
);

const MindsetIcon = ({ color }: IconProps) => (
  <IconSvg viewBox="0 0 301.63 210.33" color={color}>
    <g id="Layer_1-2">
      <g>
        <path d="M189.6,210l-.6-111.3-54,90.6h-26.4L54.9,101.7v108.3H0V0H55L122.7,111.49,188.96,0h54.65l.6,210h-54.6Z" />
        <circle cx="282.66" cy="134.44" r="18.97" />
        <circle cx="282.66" cy="191.36" r="18.97" />
        <circle cx="282.66" cy="77.52" r="18.97" />
        <circle cx="282.66" cy="20.61" r="18.97" />
      </g>
    </g>
  </IconSvg>
);

const AssessmentIcon = ({ color }: IconProps) => (
  <IconSvg viewBox="0 0 600 600" color={color}>
    <path
      d="M366.42 370.64h-88.8l-16.5 40.8h-60.6l92.7-210h58.5l93 210h-61.8zm-17.4-43.8-27-67.2-27 67.2z"
      transform="translate(-310.235 -310.4) scale(2.03003)"
    />
    <circle cx="102.755" cy="347.919" r="41.717" strokeWidth={2.03003} />
    <circle cx="51.537" cy="462.088" r="41.717" strokeWidth={2.03003} />
    <circle cx="153.972" cy="233.75" r="41.717" strokeWidth={2.03003} />
    <circle cx="205.17" cy="119.581" r="41.717" strokeWidth={2.03003} />
  </IconSvg>
);

type ProductIconProps = {
  color: string;
  product: ProductIdent;
};

export const ProductIcon = ({ color, product }: ProductIconProps) => {
  const Icon =
    product === "mindset"
      ? MindsetIcon
      : product === "lessons"
        ? LessonsIcon
        : product === "assessments"
          ? AssessmentIcon
          : null;

  if (Icon != null) {
    return <Icon color={color} />;
  }
};
